import {useUp} from 'quickstart/styled-components/system'
import {Box} from '../Box'

export const Sidebar = props =>
  useUp('lg') ? <Box col={0.25} mr="2rem" {...props} /> : null
